export interface ExpressionSuggestionRequest {
    expression: string
    cursorPosition: number
    schemaTypes: string[]
}

// WHY: pre-baked schemaTypes lists for the suggestion endpoint (issue 654 Gap 3).
// 'any' = no root restriction (schema policies); 'profile' = legacy restriction-rule
// schema; 'identity' = identity-rooted autoassign. Centralised so the wire-level
// strings live next to the request DTO instead of the calling page.
// eslint-disable-next-line i18next/no-literal-string
export const SCHEMA_TYPES_ANY: string[] = ['any']
// eslint-disable-next-line i18next/no-literal-string
export const SCHEMA_TYPES_PROFILE: string[] = ['profile']
// eslint-disable-next-line i18next/no-literal-string
export const SCHEMA_TYPES_IDENTITY: string[] = ['identity']
// WHY: certification-policy scope expressions (epic 924) are rooted at the
// `access` schema (the certified AccessProfileAssignment). Consumed by the
// not-yet-built certification ExpressionEditor + preview UI (924.05).
// eslint-disable-next-line i18next/no-literal-string
export const SCHEMA_TYPES_CERTIFICATION: string[] = ['access']

export interface ExpressionSuggestionItem {
    text: string
    displayText: string
    description: string
    category: 'field' | 'operator' | 'value' | 'logical' | 'keyword'
    valueType: string | null
    insertText: string
    kind: 'STATIC_FIELD' | 'ATTRIBUTE' | 'RELATIONSHIP_ALIAS' | null
    /**
     * Explicit replace range supplied by the engine. When present the editor
     * splices `source.slice(replaceStart, replaceEnd)` with `replaceText`
     * and ignores `insertText`. Null when the engine wants the legacy
     * "replace the current token" splice.
     */
    replaceStart: number | null
    replaceEnd: number | null
    replaceText: string | null
}

export interface ExpressionSuggestionContext {
    scope: string | null
    expecting: string
}

export interface ExpressionSuggestion {
    suggestions: ExpressionSuggestionItem[]
    context: ExpressionSuggestionContext
}
